<label translate>{{ this.conf.label }}</label><ng-content></ng-content>


// WEBPACK FOOTER //
// ./src/app/views/customerDB/customers/formElement.component.ts.FormElementComponent.html